export class DomainDTO {
  public cartIndex: string
  public name: string
  public period: number
  public idProtection: boolean
  public dnsManagement: boolean
  public emailForwarding: boolean

  constructor(
    cartIndex: string,
    name: string,
    period: number,
    idProtection: boolean,
    dnsManagement: boolean,
    emailForwarding: boolean
  ) {
    this.cartIndex = cartIndex
    this.name = name
    this.period = period
    this.idProtection = idProtection
    this.dnsManagement = dnsManagement
    this.emailForwarding = emailForwarding
  }
}
